import React from 'react'
import moment from 'moment'
import _ from 'underscore'

export default class AdminServices extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      services : {},
    };
		// websocket connections
    this.sockets = [];
  }

  componentDidMount() {
    realtime().then( (socket) => {
			this.sockets.push(socket)
      socket.onjson = (message) => {
        this.state.services[message.id] = message;
	        this.setState({
	        	services : this.state.services
	        })
      }
      socket.subscribe("service.Heartbeat.>")
    }).catch( (err) => { console.log(err) })
  }

	componentWillUnmount() {
    for (var i = 0; i < this.sockets.length; i++) {
      this.sockets[i].close();
    };
    delete this.sockets;
	}

  render() {
    return (
      <div className="row" style={{marginTop:"2em"}}>
        <div className="col-xs-offset-2 col-xs-8">
        <div className="row">
        Heartbeat Monitor
        </div>
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '15em'}}>time</th>
                        <th>name</th>
                        <th>version</th>
                        <th>status</th>
                        <th></th>
                        <th>machine</th>
                        <th style={{ width: '8em'}}>up time</th>
                    </tr>
                </thead>
                <tbody>{
                	_.map(_.sortBy(this.state.services, (svc) => svc.name + svc.id), (svc) => {
      	        		return <tr key={svc.id} className="clickable"
                               style={ (Math.abs(moment(svc.current_datetime).diff(moment(), 'seconds')) > 20 ? {opacity:0.5} : {}) }
                               >
    	        			<td>{ moment(svc.current_datetime).format("HH:mm:ss") }</td>
    	        			<td>{ svc.name }</td>
                    <td>{ "#" + svc.version }</td>
                    <td>{ svc.status }</td>
                    <td>{ svc.description }</td>
    	        			<td>{ svc.machine }</td>
    	        			<td>{ moment(svc.current_datetime).from(moment(svc.creation_datetime), true) }</td>
    	        		</tr>
    	        	})
            	}</tbody>
            </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin_services.jsx